module.exports = __webpack_public_path__ + "img/mercury.540ce64f.png";